/**
 * CP 디자인 시스템 컬러 토큰
 * Primary, Secondary, Tertiary, Semantic Colors
 */

export const colors = {
  // Primary — Teal
  primary: {
    50: '#f0fdfa',
    200: '#99f6e4',
    400: '#2dd4bf',
    500: '#14b8a6',
    600: '#0d9488',
    800: '#115e59',
  } as const,

  // Secondary — Indigo
  secondary: {
    50: '#eef2ff',
    500: '#6366f1',
    600: '#4f46e5',
  } as const,

  // Tertiary — Blue
  tertiary: {
    50: '#eff6ff',
    500: '#3b82f6',
    600: '#2563eb',
  } as const,

  // Semantic Colors
  semantic: {
    success: {
      bg: 'bg-green-50',
      text: 'text-green-600',
      icon: 'text-green-500',
    } as const,
    warning: {
      bg: 'bg-yellow-50',
      text: 'text-amber-700',
      icon: 'text-amber-500',
    } as const,
    error: {
      bg: 'bg-red-50',
      text: 'text-red-600',
      icon: 'text-red-500',
      border: 'border-red-300',
    } as const,
    info: {
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      icon: 'text-blue-500',
    } as const,
  } as const,

  // Surface / Background
  surface: {
    white: '#ffffff',
    slate50: '#f8fafc',
    slate100: '#f1f5f9',
    slate200: '#e2e8f0',
  } as const,

  // Text Colors
  text: {
    slate900: '#0f172a',
    slate800: '#1e293b',
    slate500: '#64748b',
    slate400: '#94a3b8',
  } as const,
} as const

// Helper functions for class names
export const getPrimaryColorClass = (level: keyof typeof colors.primary) =>
  `bg-primary-${level}` as const

export const getTextPrimaryColorClass = (level: keyof typeof colors.primary) =>
  `text-primary-${level}` as const
